import { FC } from 'react';

import { motion } from 'framer-motion';
import { cn } from 'utils/helpers';
import { ToadIcon } from 'ui/components/icon';

const AnimatedChatLoading: FC = () => {
  const dotVariants = (reverse: boolean) => ({
    animate: {
      y: reverse ? [-6, 6, -6] : [6, -6, 6],
      transition: {
        duration: 0.6,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  });

  return (
    <div className={cn('flex gap-2 text-sm', 'max-w-none', 'flex-1')}>
      <div
        className={cn(
          'flex-shrink-0 mt-[14px]',
          'w-10 h-10 flex items-center justify-center',
        )}
      >
        <ToadIcon className="w-9 h-9 text-primary-base flex-shrink-0" />
      </div>
      <div className={cn('p-[14px] rounded-lg max-w-full', 'bg-none')}>
        <div className="font-semibold text-xs py-2.5">Toad AI Result</div>
        <div className="flex justify-center items-center gap-2 h-10">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              variants={dotVariants(i === 1)}
              animate="animate"
              className="w-2 h-2 bg-secondary-base rounded-full"
              style={{ animationDelay: `${i * 0.2}s` }} // Staggered effect
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnimatedChatLoading;
